import { useEffect, useRef } from "react";
import { useDispatch } from 'react-redux';
import { useStoreErrors, useLogout, useClearCart, useConfig, useStorefront, useCustomer } from '@kega/sps-core';

import useCustomerCountry from "../../hooks/customer/useCustomerCountry";
import usePublicToken from "../../hooks/usePublicToken";
import isInvalidRefreshTokenError from '../../lib/auth/isInvalidRefreshTokenError';
import isInvalidTokenError from '../../lib/auth/isInvalidTokenError';
import isCartNotFoundError from '../../lib/cart/isCartNotFoundError';
import { recoverFromStaleCart } from '../../lib/cart/cartRecovery';

const Errors = () => {
    const dispatch = useDispatch();
    const logout = useLogout();
    const config = useConfig();
    const clearCart = useClearCart();
    const { authenticated } = useCustomer();
    const { api: { cart } } = useStorefront();
    const { listenError } = useStoreErrors();
    const { getPublicToken } = usePublicToken();
    const { setCountry } = useCustomerCountry();

    const authenticatedRef = useRef(authenticated);
    const cartRef = useRef(cart);

    authenticatedRef.current = authenticated;
    cartRef.current = cart;

    useEffect(() => {

        const removeErrorListener = listenError( async ({ detail }) => {

            const { status, data = null } = detail;

            if (status === 401 || isInvalidRefreshTokenError(detail) || isInvalidTokenError(detail) || isInvalidTokenError({ data })) {
                await logout();
                await getPublicToken();
            } else if (isCartNotFoundError(detail) || isCartNotFoundError({ data })) {
                await recoverFromStaleCart({
                    authenticated: authenticatedRef.current,
                    cart: cartRef.current,
                    dispatch,
                    clearCart,
                });
            } else if (data?.errors?.some((e) => e.code === 'ForbiddenError') &&
                        data?.errors?.some((e) => e.code === 'InvalidCountryError')) {

                const storeViews = config.get('storeViews');
                const storeCode = config.get('storeCode');
                const currentStoreCountry = storeViews[storeCode].country.toUpperCase();

                const oppositeCountry = currentStoreCountry === 'NL' ? 'BE' : 'NL';

                setCountry(oppositeCountry)
            }

        });

        return () => {
            removeErrorListener();
        }
    }, [ clearCart, config, dispatch, getPublicToken, listenError, logout, setCountry ]);

    return null;
}

export default Errors;